import React, { useState, useEffect } from "react";
import "./App.scss";
import Hero from "./components/Hero/Hero";
import NavBarV2 from "./components/NavBarV2/NavBarV2";
import Footer from "./components/Footer/Footer";

import {
  BrowserRouter,
  Route,
  Routes,
  useLocation
} from "react-router-dom";
import Home from "./impl/Home/Home";
import AboutFounder from "./impl/AboutFounder/AboutFounder";
import AboutMobileApps from "./impl/AboutMobileApps/AboutMobileApps";
import AboutAI from "./impl/AboutAI/AboutAI";
import AboutWebsites from "./impl/AboutWebsites/AboutWebsites";
import AboutOilAndGas from "./impl/AboutOilAndGas/AboutOilAndGas";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/" || !pathname.startsWith("/home/")) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;

    // GA4 Page View
    if (typeof window.gtag === "function") {
      window.gtag("config", "G-HHKB695VEY", {
        page_path: pagePath,
      });
      window.gtag("event", "page_view", {
        page_path: pagePath,
        send_to: "G-HHKB695VEY",
      });
    }

    // Google Tag Manager dataLayer virtual pageview
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: "pageview",
        page: pagePath,
      });
    }

    // Meta / Facebook Pixel PageView
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }

    // Hotjar stateChange
    if (typeof window.hj === "function") {
      window.hj("stateChange", pagePath);
    }
  }, [location]);

  return null;
}

function App() {
  const [navActiveLink, setNavActiveLink] = useState("default");
  const onNavUpdate = (navId) => {
    setNavActiveLink(navId);
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <AnalyticsTracker />
      <Routes>
        <Route
          path="/"
          element={
            <Hero
              title="Woodlands Digital Technologies"
              subtitle="a Texas-based Company"
              slogan="Modern Technologies & Conservative Values"
              bg_image_src={require("./assets/banner/hero.jpg")}
              cta_link="/home/services"
              cta_label="Get Started"
              main_id="hero"
              cta_id="link_get_started"
            />
          }
        />
        <Route
          path="/home/:id"
          element={
            <Hero
              title="Woodlands Digital Technologies"
              subtitle="a Texas-based Company"
              slogan="Modern Technologies & Conservative Values"
              bg_image_src={require("./assets/banner/hero.jpg")}
              cta_link="/home/services"
              cta_label="Get Started"
              main_id="hero"
              cta_id="link_get_started"
            />
          }
        />
        <Route path="*" element={null} />
      </Routes>

      <NavBarV2
        navActiveLink={navActiveLink}
        logo={require("./assets/logo.png")}
      />

      <Routes>
        <Route path="/" element={<Home onNavUpdate={onNavUpdate} />} />
        <Route path="/home/:id" element={<Home onNavUpdate={onNavUpdate} />} />
        <Route path="/about-founder" element={<AboutFounder />} />
        <Route path="/about-mobile-apps" element={<AboutMobileApps />} />
        <Route path="/about-ai" element={<AboutAI />} />
        <Route path="/about-websites" element={<AboutWebsites />} />
        <Route path="/oil-and-gas" element={<AboutOilAndGas />} />
        <Route path="/solutions/oil-and-gas" element={<AboutOilAndGas />} />
      </Routes>

      <Footer logo={require("./assets/logo.png")} />
    </BrowserRouter>
  );
}

export default App;
